/**
 * AnalysisModelService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class AnalysisModelService {
    getAllCompanies = () => {
        return apiClient.get("/getAllCompanies");
    }

    getExchangesByCompany = (body) => {
        return apiClient.post("/getExchangesByCompanyName", body);
    }

    getAllTools = () => {
        return apiClient.get("/getAllTools");
    }

    getAnalysisModels = (data) => {
        return apiClient.post("context/analysisModel/get", data);
    }

    getStyles = () => {
        return apiClient.get("/context/getAllStyles");
    }

    getMentorByStyle = (data) => {
        return apiClient.post("/context/mentorsByStyle", data);
    }

    getScreenModelByModel = (data) => {
        return apiClient.post("/context/analysisModelsByMentor", data);
    }

    getMeasuresByAnalysisModel = (data) => {
        return apiClient.post("/context/getMeasuresByAnalysisModel", data);
    }

    getCategoryByAnalysisModel = (data) => {
        return apiClient.post("/context/categoryByAnalysisModel", data);
    }

    getMetricsDropDown = (data) => {
        return apiClient.post("/context/getMetrics", data);
    }
}
